var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hidden-danger-quality-chart"},[_c('custom-panel',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("隐患数量类别分布")]},proxy:true},{key:"default",fn:function(){return [(_vm.dataLoaded)?_c('dv-charts',{attrs:{"option":_vm.option}}):_vm._e()]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }